import React from "react";
import SupportForm from "./SupportForm";
import { connect } from "react-redux";
import styled from "@emotion/styled";

const Main = styled.div`
  margin-top: 35px;
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin-bottom: 30px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 15px;
  align-items: center;

  @media (max-width: 400px) {
    grid-template-columns: 85px 1fr;
    grid-column-gap: 15px;
  }
`;

const GridItem = styled.div`
  font-size: 14px;

  @media (max-width: 310px) {
    font-size: 13px;
  }
`;

const GridItemHeader = styled(GridItem)`
  font-weight: bold;
  color: #777984;
`;

const GridItemValue = styled(GridItem)`
  color: #1f2021;
  justify-self: flex-end;

  @media (max-width: 400px) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;

const FormContainer = styled.div`
  margin-top: 35px;
`;

const SupportModal = ({ customerInfo, orderId, setFinished }) => {
  return (
    <Main>
      <Header>Contact us</Header>
      <Grid>
        <GridItemHeader>Name</GridItemHeader>
        <GridItemValue>{`${customerInfo.firstname} ${customerInfo.lastname}`}</GridItemValue>
        <GridItemHeader>Order ID</GridItemHeader>
        <GridItemValue>{`${orderId}`}</GridItemValue>
        <GridItemHeader>Email</GridItemHeader>
        <GridItemValue>{`${customerInfo.email}`}</GridItemValue>
      </Grid>
      <FormContainer>
        <SupportForm setFinished={setFinished} />
      </FormContainer>
    </Main>
  );
};

export default connect(state => ({
  customerInfo: state.customerInfo,
  orderId: state.orderAssistance.orderId
}))(SupportModal);
